import { dirname, resolve } from "path";
import { fileURLToPath } from "url";

const __dirname = dirname(fileURLToPath(import.meta.url));
const platformNodeProxySignature = resolve(__dirname, "../../platform/src/node-proxy-signature.ts");
const mod = await import(platformNodeProxySignature);

export const NODE_PROXY_CONTROL_PLANE_APP_HEADER = mod.NODE_PROXY_CONTROL_PLANE_APP_HEADER as string;
export const NODE_PROXY_DELEGATED_USER_ID_HEADER = mod.NODE_PROXY_DELEGATED_USER_ID_HEADER as string;
export const verifyNodeProxyRequestSignature = mod.verifyNodeProxyRequestSignature as (input: {
  headers: Headers;
  method: string;
  originalHost: string;
  originalPath: string;
  targetNode: string;
  secretsByKeyId: Record<string, string>;
  nowMs?: number;
  maxSkewMs?: number;
  seenNonces?: Set<string>;
}) => { ok: true; keyId: string; sourceNode: string; targetNode: string } | { ok: false; reason: string };
